import { styled } from '@mui/material/styles';
import AccordionSummary from '@mui/material/AccordionSummary';
import { CapaLlegendaVisibilityIcon } from './CapaLlegendaIcons/CapaLlegendaVisibilityIcon';

export const CustomizedAccordionSummary = styled(AccordionSummary)`
  & .MuiAccordionSummary-content {
    margin: 0px;
  }

  & .MuiAccordionSummary-content.Mui-expanded {
    margin: 0px;
  }

  & .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {
    min-height: 40px;
  }
`;

/**
 * @desc funcion para comprobar si una capa con reglas de representacion por escala está dentro de la escala del mapa
 */
const checkRange = (scale, min, max) => {
  return scale > min && scale < max;
};

/**
 * @desc funcion para ocultar los estilos de una capa con reglas de representacion por escala
 */
export const hideStyleByRange = (scale, className, layer) => {
  let escales = document.getElementsByClassName('Escala');
  let contenidorLlegenda = document.getElementById('CapesLlegendaWrapper');

  //en la leyenda no queremos mostrar el texto "Escala de x a y"
  for (var esc = 0; esc < escales.length; ++esc) {
    if (contenidorLlegenda.contains(escales[esc])) escales[esc].style.display = 'none';
  }

  let elements = document.getElementsByClassName(className);
  //para cada entrada de los estilos de la capa se comprueba si está dentro de rango. En función de esto, se oculta o muestra el estilo
  for (var i = 0; i < elements.length; i++) {
    if (contenidorLlegenda.contains(elements[i])) {
      let elems = elements[i]?.className?.split(' ');
      let range = elems[elems.length - 2]?.split('-');
      let min = parseInt(range[0]);
      let max = parseInt(range[1]);
      if (!checkRange(scale, min, max) && layer.hasChildsOrRules()) elements[i].style.display = 'none';
      else elements[i].style.display = 'inline-flex';
    }
  }
};

export const getCustomizedAccordionStyle = (isDragging) => {
  return {
    backgroundColor: '#333',
    boxShadow: isDragging ? '0px 0px 10px 1px rgba(254,191,0,0.7)' : null,
    color: '#FFF',
    pointerEvents: 'auto'
  };
};

export const getCustomizedAccordionSummaryStyle = (isDragging) => {
  return {
    margin: '0px',
    padding: '0px',
    display: '-webkit-box',
    alignItems: 'center',
    minHeight: window.innerWidth < 464 ? (isDragging ? '80px !important' : '60px !important') : isDragging ? '60px !important' : '40px !important'
  };
};

export const getLayerHeaderTitle = (layer) => {
  return layer.isExternal()
    ? layer.getFileName()
    : layer.getCurrentStyle() && layer.getCurrentStyle().getTitle() !== undefined && layer.getCurrentStyle().getTitle() !== layer.getTitle()
    ? layer.getCurrentStyle().getTitle()
    : layer.getAbstract() !== layer.getTitle()
    ? layer.getAbstract()
    : null;
};

export const checkIfLayerHasRules = (layer) => {
  return (
    layer.hasStyles() &&
    layer.getCurrentStyle() !== undefined &&
    layer.getCurrentStyle().getNumRules() !== undefined &&
    layer.getCurrentStyle().getNumRules() > 0 &&
    layer.hasChildsOrRules()
  );
};

/**
 * @desc Función encargada de cambiar el icono si las rules no se ven por escala
 */
export const scaleSvgFill = (layer, scale, fontSizeEnabled) => {
  let rulesVisible = 0;
  let rulesWithoutMaxScale = 0;
  if (layer.getCurrentStyle().rules.length > 1) {
    layer.getCurrentStyle().rules?.forEach((rule) => {
      if (!rule.MaxScaleDenominator) {
        rulesWithoutMaxScale += 1;
        rulesVisible += 1;
      } else if (rule.MaxScaleDenominator && rule.MaxScaleDenominator > scale) {
        rulesVisible += 1;
      }
    });
  } else {
    if (layer.getCurrentStyle().rules.MaxScaleDenominator && layer.getCurrentStyle().rules.MaxScaleDenominator > scale) {
      rulesVisible += 1;
    } else if (!layer.getCurrentStyle().rules.MaxScaleDenominator) {
      rulesWithoutMaxScale += 1;
      rulesVisible += 1;
    }
  }
  if (rulesVisible === 0) {
    layer.setIsOnRange(false);
  } else {
    layer.setIsOnRange(true);
  }
  if (rulesWithoutMaxScale === layer.getCurrentStyle().rules.length) {
    return <CapaLlegendaVisibilityIcon fontSizeEnabled={fontSizeEnabled} layer={layer} type="visible" />;
  } else {
    return <CapaLlegendaVisibilityIcon fontSizeEnabled={fontSizeEnabled} layer={layer} type="has-scale" />;
  }
};
